import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
export default function ItemCount(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="border-radius border-brand-primary/30 rounded-full border border-solid px-2.5 py-0.5 text-xs"><b className="text-brand-primary">{children}</b></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}